import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function ServiceAreaBanner() {
  const areas = [
    "Trinity, FL",
    "New Port Richey",
    "Tampa",
    "Clearwater",
    "Palm Harbor",
    "Land O' Lakes",
    "Lutz",
    "Wesley Chapel",
    "Dunedin",
    "Oldsmar",
    "Keystone",
    "East Lake",
    "Spring Hill",
    "Brooksville",
    "Holiday",
    "Tarpon Springs",
    "Odessa",
    "Elfers",
    "Port Richey",
    "Bellair",
    "Clearwater Beach"
  ];

  // Cities in the list above that have a dedicated geo page. Only these are
  // linkified; the rest stay as plain text (no page to link to).
  const CITY_PAGES = {
    "Trinity, FL": "/trinity-fl",
    "New Port Richey": "/new-port-richey-fl",
    "Tampa": "/tampa-fl",
    "Clearwater": "/clearwater-fl",
    "Palm Harbor": "/palm-harbor-fl",
    "Land O' Lakes": "/land-o-lakes-fl",
    "Lutz": "/lutz-fl",
    "Wesley Chapel": "/wesley-chapel-fl",
    "Dunedin": "/dunedin-fl",
    "Oldsmar": "/oldsmar-fl",
    "Keystone": "/keystone-fl",
    "Spring Hill": "/spring-hill-fl",
    "Brooksville": "/brooksville-fl",
    "Holiday": "/holiday-fl",
    "Tarpon Springs": "/tarpon-springs-fl",
    "Odessa": "/odessa-fl",
    "Port Richey": "/port-richey-fl",
  };

  return (
    <section className="py-12 bg-gradient-to-r from-slate-50 to-amber-50/30 border-y border-slate-100">
      <div className="container mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <div className="flex items-center justify-center gap-2 mb-4">
            <MapPin className="w-5 h-5 text-amber-600" />
            <h3 className="text-lg font-medium text-slate-800">
              Proudly Serving the Greater Tampa Bay Area
            </h3>
          </div>
          <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
            {areas.map((area, index) => {
              const href = CITY_PAGES[area];
              const cls = "px-4 py-2 bg-white rounded-full text-sm text-slate-700 border border-slate-200 hover:border-amber-300 hover:shadow-sm transition-all";
              return (
                <motion.span
                  key={area}
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.05 }}
                >
                  {href ? (
                    <Link to={href} className={cls}>{area}</Link>
                  ) : (
                    <span className={cls}>{area}</span>
                  )}
                </motion.span>
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
}